module.exports = __webpack_public_path__ + "static/media/img_Inscription_free2@2x.b33598be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_Inscription_free2@2x.png
// module id = 986
// module chunks = 0